import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"top":!_vm.bottom,"bottom":_vm.bottom,"max-width":"400px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VIcon,_vm._g({attrs:{"color":"darkgray","dark":"","size":"30"}},on),[_vm._v("mdi-information")])]}}])},[(_vm.message)?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e(),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.tooltipText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }